// Oktatas component translations

export const OKTATAS_TRANSLATIONS = {
    hu: {
        esgTitle: "ESG 1.3 Hallgatóközpontú tanulás, tanítás és értékelés",
        pageTitle: "8. Oktatás",
        
        section1: {
            title: "8.1. Az oktatás módszertani fejlesztésének irányai",
        },
        
        section2: {
            title: "8.2. Projektfeladatok az oktatásban",
            question1: "A szakon vannak-e projektfeladatos tantárgyak",
            question2: "Projektfeladatos tantárgyak száma",
            question3: "Projekt témák forrása",
        },
        
        section3: {
            title: "8.3. Mesterséges intelligencia (MI) megoldások és alkalmazások megjelenése a szakon",
            question: "MI tartalmak típusa (kérjük a kiválasztás után, a lenyíló megjegyzés mezőben nevezze meg a konkrét megjelenést (pl. Tantárgy neve, neptunkódja, modul, specializáció neve, alkalmazás):",
        },
        
        section4: {
            title: "8.4. Külső szakmai partnerrel együttműködések",
            question: "Vannak-e külső szakmai partnerekkel való együttműködések"
        },
        
        section5: {
            title: "8.5. Szakképzési együttműködések bemutatása",
            source: "Forrás:",
            question1: "Vannak-e a szakképző intézményekkel kötött megállapodások",
            question2: "Kreditbeszámítás és elismerés",
            description: "A szakképzésben szerzett tudás elismerésének módja:"
        },
        
        section6: {
            title: "8.6. Duális képzési együttműködések",
            source: "Forrás:",
            question: "A szakon működik-e duális képzés"
        },
        
        section7: {
            mainTitle: "8.7. Oktatás monitorozása",
            aacsbTitle: "8.7.a Nem STEM képzési területhez kapcsolódó képzések (AACSB)",
            aacsbDescription1: "AoL (Assurance of Learning) szak-szintű értékelése",
            aacsbDescription2: "Kérjük jelölje meg, hogyan teljesültek a szak Learning Goaljai és milyen fejlesztési igényeket azonosít a szakfelelős.",
            aacsbQuestion: "Mely Learning Goal(ok) mérésére került sor az adott félévben",
            
            abetTitle: "8.7.b Műszaki, informatikai, agrár képzési területhez (STEM) kapcsolódó képzések (ABET)",
            abetDescription1: "Szak-szintű értékelés (Student Assessment)",
            abetDescription2: "Kérjük jelölje meg, hogyan teljesültek a szak Student Outcome-jai és milyen fejlesztési igényeket azonosít a szakfelelős.",
            abetQuestion: "Mely Student Outcome(ok) mérésére került sor az adott félévben"
        },
        
        section8: {
            title: "8.8. A mérési eredmények szak-szintű összefoglalása"
        },
        
        section9: {
            title: "8.9. Az oktatás során, mely területeken mutatkoztak teljesítménybeli kihívások (több válasz jelölhető)",
        },
        
        section10: {
            title: "8.10. Fejlesztési javaslatok (több válasz jelölhető)",
            noteLabel: "Megjegyzés (opcionális):",
        },
        
        buttons: {
            previous: "Előző szakasz",
            next: "Következő szakasz",
            save: "Mentés",
            finalize: "Véglegesítés",
            unfinalize: "Véglegesítés visszavonása"
        },
        
        alerts: {
            requiredFields: "Minden mezőt ki kell tölteni!"
        },
        
        sidebar: [
            "Szak alapadatok",
            "A képzés",
            "A szak mintatanterve",
            "Tehetséges, kiemelkedő hallgatói teljesítmények",
            "Idegen nyelvi követelmények",
            "Kötelező szakmai gyakorlat",
            "Mintatanterv fejlesztések, módosítások",
            "Fejlesztési javaslatok",
            "Oktatás",
            "A szak hallgatóira vonatkozó adatok",
            "Versenytárs elemzés",
            "Meghívott előadók és óraadók",
            "Oktatók értékelése",
            "A képzés tanulmányi körülményei",
            "A szak kommunikációja",
            "Fejlesztési javaslatok megvalósítása és értékelése",
            "Szakjelentés lezárása"
        ]
    },
    
    en: {
        esgTitle: "ESG 1.3 Student-Centred Learning, Teaching and Assessment",
        pageTitle: "8. Teaching",
        
        section1: {
            title: "8.1 Directions for the Development of Teaching Methodologies",
        },
        
        section2: {
            title: "8.2 Project-Based Assignments in Teaching",
            question1: "Are there courses with project-based assignments within the programme",
            question2: "Number of courses with project-based assignments",
            question3: "Sources of project topics",
        },
        
        section3: {
            title: "8.3 Integration of Artificial Intelligence (AI) Solutions and Applications within the Programme",
            question: "Types of AI-related content (After making your selection, please specify the appearance in the comment field (e.g., course name, Neptun code, module, specialisation name, application):",
        },
        
        section4: {
            title: "8.4 Cooperation with External Professional Partners",
            question: "Are there collaborations with external professional partners"
        },
        
        section5: {
            title: "8.5 Presentation of Vocational Education and Training (VET) Collaborations",
            source: "Source:",
            question1: "Are there agreements in place with vocational education and training institutions",
            question2: "Credit recognition and transfer",
            description: "Method of recognition of learning outcomes acquired through vocational education and training"
        },
        
        section6: {
            title: "8.6 Dual Education and Training Collaborations",
            source: "Source:",
            question: "Is a dual education and training programme implemented within the programme"
        },
        
        section7: {
            mainTitle: "8.7. Monitoring of Teaching and Learning",
            aacsbTitle: "8.7.a Non-STEM-related programmes (AACSB)",
            aacsbDescription1: "Programme-level Assurance of Learning (AoL) Assessment",
            aacsbDescription2: "Please indicate the extent to which the programme’s Learning Goals have been achieved and identify any development needs identified by the Programme Director.",
            aacsbQuestion: "Which Learning Goal(s) were assessed during the given semester",
            
            abetTitle: "8.7.b Programmes related to science, technology, engineering, and mathematics (STEM) (ABET)",
            abetDescription1: "Programme-level Assessment (Student Assessment)",
            abetDescription2: "Please indicate the extent to which the programme’s Student Outcomes have been achieved and identify any development needs identified by the Programme Director.",
            abetQuestion: "Which Student Outcome(s) were assessed during the given semester"
        },
        
        section8: {
            title: "8.8. Programme-level summary of assessment results"
        },
        
        section9: {
            title: "8.9. During the educational process, in which areas were performance-related challenges identified (multiple answers may be selected)",
        },
        
        section10: {
            title: "8.10. Development recommendations (multiple answers may be selected)",
            noteLabel: "Comments (optional):",
        },
        
        buttons: {
            previous: "Previous section",
            next: "Next section",
            save: "Save",
            finalize: "Finalize",
            unfinalize: "Withdraw finalization"
        },
        
        alerts: {
            requiredFields: "All fields must be filled!"
        },
        
        sidebar: [
            "Programme Basic Data",
            "The Programme",
            "Programme Curriculum",
            "Talented Students and Outstanding Student Performance",
            "Foreign Language Requirements",
            "Compulsory Professional Practice",
            "Curriculum Developments and Modifications",
            "Development Recommendations",
            "Teaching",
            "Data related to the major",
            "Competitor Analysis",
            "Guest Lecturers and Part-time Teachers",
            "Assessment of Teachers",
            "Study Conditions",
            "Programme Communication",
            "Implementation and Evaluation of Development Recommendations",
            "Finalisation of Programme Report"
        ]
    }
};
